module.exports = __webpack_public_path__ + "static/media/logo_satebco.924265af.png";


//////////////////
// WEBPACK FOOTER
// ./public/imagenes/logo_satebco.png
// module id = 6742
// module chunks = 0